// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"6dd26279","850":"6c4034e7"}[chunkId] + ".chunk.js";
};